import React, { useEffect, useState } from "react";
import { Button, Modal, ModalProps, Form } from "react-bootstrap";
import { OrderStatus as OrderStatusEnum } from "../../enums/status";
import { transformToOrderStatus } from "../Table/transformers";
import { useMutation, useQuery } from "react-query";
import { OrderService } from "../../services/order";
import { OrderStatusService, OrderStatus } from "../../services/orderStatus";
import { FormattedMessage } from "react-intl";
import { Action, BasePermission } from "../../enums/permissions";
import Authorize from "../Permission/Authorize";

const ChangeOrderStatus: React.FC<ModalProps & { order: any }> = ({
  order,
  ...props
}) => {
  const [nextStatus, setNextStatus] = useState<OrderStatus | null>(null);
  const [comment, setComment] = useState("");

  // Fetch the next status from the backend
  const nextStatusQuery = useQuery(
    ["nextStatus", order?.status?.id],
    () => OrderStatusService.getNextStatus(order?.status?.id),
    {
      enabled: !!order?.status?.id,
      staleTime: 60 * 60 * 24 * 6,
      onSuccess: (data) => {
        setNextStatus(data);
      },
    },
  );

  const updateStatusMutation = useMutation(() =>
    OrderService.updateStatus(order.id, comment),
  );

  const cancelOrderMutation = useMutation(() =>
    OrderService.updateStatus(order.id, comment, "canceled"),
  );

  const onUpdate = async () => {
    await updateStatusMutation.mutateAsync();
    setComment("");
    if (props.onHide) props.onHide();
  };

  const onCancel = async () => {
    await cancelOrderMutation.mutateAsync();
    setComment("");
    if (props.onHide) props.onHide();
  };

  // If there's no next status, don't show the modal content
  if (nextStatusQuery.isLoading) {
    return (
      <Modal {...props}>
        <Modal.Header closeButton>
          <Modal.Title>Actualizar estado del pedido</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Cargando...</p>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <Modal {...props}>
      <Modal.Header closeButton>
        <Modal.Title>Actualizar estado del pedido</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Haga click en cambiar para mover el pedido al siguiente estado que
          corresponde.
        </p>
        <b>Estado actual:</b> {transformToOrderStatus(order?.status)}
        <Form.Group className="mt-3">
          <Form.Label>Comentario (opcional)</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Agregue un comentario sobre este cambio de estado..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Authorize actions={[Action.MANAGE]} subjects={[BasePermission.Order]}>
          <Button variant="danger" onClick={onCancel}>
            <FormattedMessage id="Cancel Order" />{" "}
            <em className="icon ni ni-alert" style={{ marginLeft: "3px" }}></em>
          </Button>
        </Authorize>

        {nextStatus && (
          <Button
            variant={
              (OrderStatusEnum as any)[nextStatus.name]?.class || "primary"
            }
            disabled={updateStatusMutation.isLoading}
            onClick={onUpdate}
          >
            Cambiar a<em className="icon ni ni-arrow-right mx-2"></em>
            {nextStatus.description}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ChangeOrderStatus;
